<template>
  <div class="content-wrap">
    <div class="error-page">
      <div class="in-error-page">
        <div class="in-in-error-page">
          <br />
          <br />
          <h2>404</h2>
          <h3>Ooops, algo deu errado</h3>
          <br />
          <br />
          <p>
            Pedimos desculpas, não estamos conseguindo recuperar as informações
            no momento.
          </p>
          <p>Por favor, tente novamente mais tarde.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPage"
};
</script>

<style></style>
